<template>
    <!--<bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">-->
          <!--<component  :is="currentTab" :currentTab='currentTab'></component>-->
    <!--</bsp-tabs>-->
<div class="payrollBox" style="margin-bottom: -5px">
  <el-tabs v-model="tabIndex"  type="card" style="height: calc(100vh - 80px);"  @tab-click="changeTab">
    <el-tab-pane
      :key="item.name"
      v-for="item in tabList"
      :label="item.title"
      :name="item.name"
      lazy="true"
    >
      <span slot="label">{{item.title}}<el-badge :value="item.num"></el-badge></span>
      <component  :is="item.name"></component>
    </el-tab-pane>
    <div class="btnCon">
      <el-button style="background:rgba(64,158,255,1);color:rgba(255,255,255,1);" type="primary" size="small" @click="download">下载申报表</el-button>
      <backBtn @reOnClick = "backToCodeSet()" style="display: inline-block;margin-left: 10px;"></backBtn>
    </div>
  </el-tabs>
</div>
</template>
<script>
 import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs";
  import taxEmpLsit from '@/views/wage/salaryTax/taxtabson/taxEmpLsit';
  import taxNormalWagesList from '@/views/wage/salaryTax/taxtabson/taxNormalWagesList';
  import taxResidentWagesList from '@/views/wage/salaryTax/taxtabson/taxResidentWagesList';
 import taxIncomeWagesList from '@/views/wage/salaryTax/taxtabson/taxIncomeWagesList';
 import taxPersonEquityList from '@/views/wage/salaryTax/taxtabson/taxPersonEquityList';
 import taxQuitWagesList from '@/views/wage/salaryTax/taxtabson/taxQuitWagesList';
 import taxAnnualWagesList from '@/views/wage/salaryTax/taxtabson/taxAnnualWagesList';
 import taxRemunerationList from '@/views/wage/salaryTax/taxtabson/taxRemunerationList';
 import taxLoyalitiesList from '@/views/wage/salaryTax/taxtabson/taxLoyalitiesList';
 import taxInterestList from '@/views/wage/salaryTax/taxtabson/taxInterestList';
 import taxAccidentalList from '@/views/wage/salaryTax/taxtabson/taxAccidentalList';
 import taxTransPropertyList from '@/views/wage/salaryTax/taxtabson/taxTransPropertyList';
 import taxLeasePropertyList from '@/views/wage/salaryTax/taxtabson/taxLeasePropertyList';
 import otherIncomeWagesList from '@/views/wage/salaryTax/taxtabson/otherIncomeWagesList';


 import {checkTitle} from "@/api/tax/tax.js";
 import backBtn from '@/wage-components/back-btn/back-btn'
	import {exportExcleSheets} from "@/api/common/common"
  import { downloadFile } from '@/util/util';


  export default {
    data() {
      return {
        tabList: [{
          title: '人员信息',
          name: 'taxEmpLsit',
          num:0
        },
        ],
        tabIndex: 'taxEmpLsit',
        // currentTab:'tabson1',
      }
    },
    created() {
      let taxType = this.$route.query.taxType;
      let taxReportTime = this.$route.query.taxReportTime;
      if(taxType.indexOf('92450001')>=0||taxType.indexOf('92450002')>=0){
        let query ={
          batchId:this.$route.query.batchId,
          taxReportTime:taxReportTime,
          taxType:taxType,
          taxReportTime : this.$route.query.taxReportTime
        }
        this._checkTitle(query);
      }

    },
    components:{
        bspTabs,
      taxEmpLsit,
      taxNormalWagesList,
      taxResidentWagesList,
      taxIncomeWagesList,
      taxPersonEquityList,
      taxQuitWagesList,
      taxAnnualWagesList,
      taxRemunerationList,
      taxLoyalitiesList,
      taxInterestList,
      taxAccidentalList,
      taxTransPropertyList,
      taxLeasePropertyList,
      otherIncomeWagesList,
      backBtn

    },
    methods: {
      changeTab(tab, event) {
        //  this.currentTab = tab.name;
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
      _checkTitle(query){
        checkTitle(query).then(res => {
          if(res.data[0].empCount>0){
            this.tabList[0]['num']=res.data[0].empCount;
          }
          if(res.data[0].normalCount>0){
            this.tabList.push({
                title: '正常工资所得',
                name: 'taxNormalWagesList',
                num:res.data[0].normalCount
              });
          }
          if(res.data[0].TaxResidentWagesCount>0) {
            this.tabList.push({
              title: '非居民正常工资薪金所得',
              name: 'taxResidentWagesList',
              num:res.data[0].TaxResidentWagesCount
            });
          }
          if(res.data[0].getTaxIncomeWagesCount>0) {
            this.tabList.push({
              title: '劳务报酬所得',
              name: 'taxIncomeWagesList',
              num:res.data[0].getTaxIncomeWagesCount
            });
          }
          if(res.data[0].getTaxPersonEquityCount>0) {
            this.tabList.push({
              title: '个人股权激励收入',
              name: 'taxPersonEquityList',
              num:res.data[0].getTaxPersonEquityCount
            });
          }
          if(res.data[0].getTaxQuitWagesCount>0) {
            this.tabList.push({
              title: '解除劳动合同一次性补偿金',
              name: 'taxQuitWagesList',
              num:res.data[0].getTaxQuitWagesCount
            });
          }
          if(res.data[0].getTaxAnnualWagesCount>0) {
            this.tabList.push({
              title: '全年一次性奖金',
              name: 'taxAnnualWagesList',
              num:  res.data[0].getTaxAnnualWagesCount
            });
          }
          if(res.data[0].getTaxRemunerationCount>0) {
            this.tabList.push({
              title: '稿酬所得',
              name: 'taxRemunerationList',
              num:  res.data[0].getTaxRemunerationCount
            });
          }
            if(res.data[0].getLoyalitiesCount>0) {
              this.tabList.push({
                title: '特权使用费所得',
                name: 'taxLoyalitiesList',
                num:  res.data[0].getLoyalitiesCount
              });
            }
            if(res.data[0].getTaxInterestCount>0) {
              this.tabList.push({
                title: '股息红利所得',
                name: 'taxInterestList',
                num:  res.data[0].getTaxInterestCount
              });
            }
            if(res.data[0].getTaxAccidentalCount>0) {
              this.tabList.push({
                title: '偶然所得',
                name: 'taxAccidentalList',
                num:  res.data[0].getTaxAccidentalCount
              });
            }
            if(res.data[0].getTaxTransPropertyCount>0) {
              this.tabList.push({
                title: '财产转让所得',
                name: 'taxTransPropertyList',
                num:  res.data[0].getTaxTransPropertyCount
              });
            }
            if(res.data[0].getTaxLeasePropertyCount>0) {
              this.tabList.push({
                title: '财产租赁所得',
                name: 'taxLeasePropertyList',
                num:  res.data[0].getTaxLeasePropertyCount
              });
            }
            if(res.data[0].getOtherIncomeWagesCount>0) {
              this.tabList.push({
                title: '其他连续劳务所得',
                name: 'otherIncomeWagesList',
                num:  res.data[0].getOtherIncomeWagesCount
              });
            }

        })
      },
      download(cardData){
        let batchId = this.$route.query.batchId;
        let taxType = this.$route.query.taxType;
        let taxReportTime = this.$route.query.taxReportTime;
        let taxCompanyName = this.$route.query.taxCompanyName;
        exportExcleSheets({
              columns:[],
              type: "excel",
              beanName: "taxServiceImpl",
              methodName: "exportTax",
              batchId: 	batchId,
          taxReportTime:taxReportTime,
              taxType:	taxType,
              isSort: true,
              headerRowNum: 1,
              fileName: taxReportTime+taxCompanyName+"申报表",
              fileType: ".xls",
            },"/wage").then(res => {
          downloadFile(res)
        })
			}
    }
  }
</script>
<style scoped>
  .btnCon{
    position: absolute;
    right: 0;
    top: -32px;
  }
</style>
